import { Phone, Mail, MapPin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_solar-energy-savings/artifacts/4q9fuk03_SIMBOLO%20SOLISY.png";

export const Footer = () => {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="relative" style={{ background: "#070e1f" }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img src={LOGO_URL} alt="Solisy" className="h-10 w-auto" />
              <span className="text-xl font-bold text-white">SOLISY</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed max-w-sm">
              Soluções completas em energia solar. Economize com a assinatura de energia ou instale seus próprios painéis solares. 
              Atendimento em todo o Brasil.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Serviços</h4>
            <ul className="space-y-3">
              {[
                { label: "Energia por Assinatura", href: "#geracao-distribuida" },
                { label: "Painéis Solares", href: "#instalacao" },
                { label: "Simulador", href: "#simulador" },
                { label: "Depoimentos", href: "#depoimentos" },
                { label: "Contato", href: "#contato" },
              ].map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => scrollTo(link.href)}
                    className="text-slate-400 hover:text-[#f5b731] text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contato</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <Phone className="w-4 h-4 text-[#f5b731] flex-shrink-0" />
                (31) 98825-5042
              </li>
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <Phone className="w-4 h-4 text-[#f5b731] flex-shrink-0" />
                (31) 98429-7314
              </li>
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <Mail className="w-4 h-4 text-[#f5b731] flex-shrink-0" />
                gabriel@solisy.com.br
              </li>
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <MapPin className="w-4 h-4 text-[#f5b731] flex-shrink-0" />
                Belo Horizonte, MG
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-xs">
            &copy; {new Date().getFullYear()} Solisy. Todos os direitos reservados.
          </p>
          <p className="text-slate-500 text-xs">
            Energia solar por geração distribuída e instalação de painéis solares - ANEEL
          </p>
        </div>
      </div>
    </footer>
  );
};
